import React, { useEffect } from "react";
import Loader from "../Loader.tsx";
import { getContractPdf } from "../../services/colaborador.pdf.service.ts";
import { notification } from "../../utils/Notifications.tsx";
import { fetchContractByCandidate } from "../../services/contract.service.ts";
import { Partner } from "../../models/Partner.ts";
import { Contract } from "../../models/Contract.ts";
import {
  getFileById,
  getFilePreviewById,
} from "../../services/proceedings.service.ts";
import { IContract, Signature } from "../../interfaces/others/IContract.ts";
import SignContract from "./SignContract.tsx";

import { getProfileTabPaneClass } from "./profileTabUtils.ts";

const Contracts = ({
  partner,
  isTabActive = false,
  embedded = false,
}: {
  partner: Partner;
  isTabActive?: boolean;
  embedded?: boolean;
}) => {
  const tabPaneClass = getProfileTabPaneClass(isTabActive, embedded);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [contracts, setContracts] = React.useState<Contract[]>([]);
  const [contract, setContract] = React.useState<IContract>({});
  const componentRef = React.useRef() as React.MutableRefObject<any>;
  const [showContract, setShowContract] = React.useState<boolean>(false);

  const generateContract = async (colaboratorId) => {
    setLoading(true);
    try {
      const response = await getContractPdf(partner.id);
      let signatureUrl: Signature;

      console.log('contract', response);
      if (response?.signature?.id) {
        signatureUrl = await getFileById(response.signature.id)
        response.signature.url = signatureUrl?.url;
      }
      setContract(response);
      if (response.signature?.url) {
        setShowContract(true);
      }
    } catch (error) {
      notification(
        "Error",
        "Ocurrió un error al descargar el contrato",
        "danger"
      );
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchContracts(partner);
  }, [partner]);

  const fetchContracts = async (partner) => {
    try {
      const response = await fetchContractByCandidate(partner.candidate.id);
      console.log('contracts', response);
      setContracts(response);
    } catch (error) {
      console.log(error, " fetch contract");
    }
  };

  useEffect(() => {
    if (contracts.length > 0) {
      Promise.all(
        contracts.map(async (contract) => {
          try {
            const response = await getFilePreviewById(contract.file.id);
            return response;
          } catch (error) {
            console.log(error, " fetch contract");
          }
        })
      );
    }
  }, [contracts]);

  const getMissingFields = (person: any): string[] => {
    const excludedFields = [
      "tipoSangre",
      "tratamiento",
      "alergias",
      "enfermedad",
      "fromPhone",
      "id",
      "createdAt",
      "updateAt",
      "isBanned",
      "schooling",
      "idSchooling",
      "curp",
    ];

    const fieldLabels: { [key: string]: string } = {
      firstName: "Nombre",
      lastName: "Apellido Paterno",
      secondLastName: "Apellido Materno",
      email: "Correo electrónico",
      phone: "Teléfono",
      address: "Domicilio",
      birthdate: "Fecha de nacimiento",
      genere: "Género",
      maritalStatus: "Estado civil",
      rfc: "RFC",
      nss: "Número de Seguro Social",
      idMex: "IDMEX",
      ocr: "OCR",
      idSchooling: "Escolaridad",
    };

    const missingFields: string[] = [];

    for (let key in person) {
      if (!person.hasOwnProperty(key)) continue;
      if (excludedFields.includes(key)) continue;

      if (key === "nss") {
        const nssValue = person[key];
        if (!nssValue || nssValue === "" || nssValue === null) {
          missingFields.push(fieldLabels[key] || key);
        } else {
          const nssDigits = String(nssValue).replace(/\D/g, "");
          if (nssDigits.length !== 10 && nssDigits.length !== 11) {
            missingFields.push(`${fieldLabels[key] || key} (debe tener 10 u 11 dígitos)`);
          }
        }
        continue;
      }

      if (person[key] === "" || person[key] === null || person[key] === undefined) {
        if (fieldLabels[key]) {
          missingFields.push(fieldLabels[key]);
        }
      }
    }

    return missingFields;
  };

  const downloadStoredContract = async (fileId: string, fileName: string) => {
    setLoading(true);
    try {
      const preview = await getFilePreviewById(fileId);
      const response = await fetch(preview.url);
      if (!response.ok) {
        throw new Error(`download ${response.status}`);
      }
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = objectUrl;
      anchor.download = fileName;
      anchor.click();
      URL.revokeObjectURL(objectUrl);
    } catch (error) {
      notification("Error", "Ocurrió un error al descargar el contrato", "danger");
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const storedContractList = contracts.length > 0 && (
    <div className="mb-3">
      {contracts.map((item) => (
        <button
          key={item.id}
          type="button"
          className="btn btn-primary me-2"
          onClick={() =>
            downloadStoredContract(
              item.file.id,
              `${item.file.name}.${item.file.extension}`,
            )
          }
        >
          Descargar contrato
        </button>
      ))}
    </div>
  );

  const missingFields = getMissingFields(partner?.person || {});
  const isEmpty = missingFields.length > 0;

  if (isEmpty)
    return (
      <div className={tabPaneClass} id="contrato" style={{ padding: "0 12px" }}>
        {storedContractList}
        {contracts.length === 0 && (
        <div style={{
          width: "100%",
          background: "#fff3cd",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          overflow: "hidden",
          marginTop: "12px",
          minHeight: "400px",
          padding: "20px 24px",
        }}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "20px" }}>
              <div style={{
                width: "48px",
                height: "48px",
                borderRadius: "50%",
                background: "#ffc107",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}>
                <i className="fa-solid fa-exclamation-triangle" style={{ fontSize: "24px", color: "#000" }}></i>
              </div>
              <div>
                <h3 style={{ margin: 0, color: "#856404", fontSize: "20px", fontWeight: "700" }}>
                  Información incompleta
                </h3>
                <p style={{ margin: "2px 0 0 0", color: "#856404", fontSize: "14px" }}>
                  No se puede generar el contrato en este momento
                </p>
              </div>
            </div>
          <div>
            <p style={{ 
              margin: "0 0 16px 0", 
              color: "#374151", 
              fontSize: "14px",
              lineHeight: "1.5" 
            }}>
              El colaborador no cuenta con información suficiente para generar el contrato. 
              Por favor, completa los siguientes campos en <strong>Datos generales</strong>:
            </p>
            <div style={{
              background: "rgba(255, 255, 255, 0.6)",
              borderRadius: "8px",
              padding: "16px",
              border: "1px solid rgba(0, 0, 0, 0.1)",
            }}>
                <div style={{ marginBottom: "12px" }}>
                  <strong style={{ color: "#374151", fontSize: "14px", display: "flex", alignItems: "center", gap: "6px" }}>
                    <i className="fa-solid fa-list-check" style={{ color: "#ffc107", fontSize: "14px" }}></i>
                    Campos faltantes ({missingFields.length}):
                  </strong>
                </div>
                <ul style={{ 
                  margin: 0, 
                  paddingLeft: "20px", 
                  color: "#6b7280", 
                  fontSize: "13px",
                  lineHeight: "1.8",
                  columns: missingFields.length > 4 ? 3 : missingFields.length > 2 ? 2 : 1,
                  columnGap: "24px",
                }}>
                  {missingFields.map((field, index) => (
                    <li key={index} style={{ marginBottom: "4px", breakInside: "avoid" }}>
                      <i className="fa-solid fa-circle-dot" style={{ fontSize: "6px", color: "#ffc107", marginRight: "6px" }}></i>
                      {field}
                    </li>
                  ))}
                </ul>
            </div>
            <div style={{ marginTop: "20px", paddingTop: "20px", borderTop: "1px solid rgba(0, 0, 0, 0.1)" }}>
              <p style={{ margin: 0, color: "#856404", fontSize: "13px", fontStyle: "italic" }}>
                <i className="fa-solid fa-info-circle me-2" style={{ color: "#856404", fontSize: "12px" }}></i>
                Una vez que completes todos los campos requeridos, podrás generar el contrato desde esta sección.
              </p>
            </div>
          </div>
        </div>
        )}
      </div>
    );

  return (
    <div className={tabPaneClass} id="contrato">
      {storedContractList}
      {
        showContract ? (
          <React.Fragment>
            <SignContract ref={componentRef} contractData={contract} partner={partner} refetch={generateContract} />
            <Loader isLoading={loading} />
          </React.Fragment>
        ) : (
          <div className="alert alert-warning w-50 mx-auto" role="alert">
            <h4 className="alert-heading fs-30px">¡Atención!</h4>
            <p className="fs-17px">
              La información contenida en el siguiente contrato es estrictamente confidencial y privada. Está prohibido compartir, divulgar o distribuir cualquier parte de este documento sin el consentimiento expreso y por escrito de las partes involucradas.
            </p>
            <p className="fs-17px">
              Por favor, asegúrese de leer detenidamente todo el contenido del contrato para comprender completamente los términos y condiciones establecidos.
            </p>
            <hr />
            <p className="fs-17px">
              Al hacer clic en "Aceptar", usted confirma que ha leído y comprendido este aviso y acepta los términos de confidencialidad y privacidad aquí mencionados.
            </p>

            <div className="d-flex justify-content-end mt-4">
              <button
                className="btn btn-secondary me-4"
                onClick={() => setShowContract(false)}
              >
                Cancelar
              </button>
              <button
                className="btn btn-primary"
                onClick={() => setShowContract(true)}
              >
                Aceptar
              </button>
            </div>
          </div>
        )
      }
    </div>
  );
};

export default Contracts;
